import { Pipe, PipeTransform } from '@angular/core';
import { CandidatStatusOnMission } from '../utils/enums';

@Pipe({
  name: 'stausCandidatMissionColorEnums',
})
export class StausCandidatMissionColorEnumsPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    switch (value) {
      case CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION:
        return 2;
      case CandidatStatusOnMission.CONTRACT_PENDING_VALIDATION:
        return 2;
      case CandidatStatusOnMission.ACCEPTED:
        return 1;
      case CandidatStatusOnMission.CANCELED_BY_ESTABLISHMENT:
        return 3;
      case CandidatStatusOnMission.REJECTED:
        return 3;
      case CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH:
        return 1;
      case CandidatStatusOnMission.PAYMENT_DONE:
        return 4;
      case CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION:
        return 4;
      case CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT:
        return 4;
      case CandidatStatusOnMission.ARCHIVED:
        return 4;
      case CandidatStatusOnMission.NEUTRAL:
        return 0;
      case CandidatStatusOnMission.RESERVED:
        return 4;
      case CandidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT:
        return 3;
      case CandidatStatusOnMission.CANCELLATION_ACCEPTED_AFTER_SIGNING:
        return 3;
      case CandidatStatusOnMission.CANCELLATION_REQUEST_AFTER_SIGN_CONTRACT:
        return 3;
      case CandidatStatusOnMission.CANCELED_BY_CANDIDATE:
        return 3;
      case CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY:
        return 3;
      default:
        return 0;
    }
  }
}
